import React, { useEffect, useState } from "react";
import "./BlogsComponent.css";
import { useNavigate } from "react-router-dom";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
} from "../../Pages/utils/page";
import axios from "axios";
import { toast } from "react-toastify";

const BlogsComponent = () => {
  const navigate = useNavigate();
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [blogsCardData, setBlogsCardData] = useState([]);
  const [discriptionDataFromId, setDiscriptionDataFromId] = useState();

  const fetchBlogsCards = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/GetBlogsForCustomers`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setBlogsCardData(Array.isArray(data) ? data : []);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchBlogsCards();
  }, []);

  const handleReadMore = (item) => {
    const data = {
      id: item?.Id,
    };
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/Customer/GetBlogById`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        const finalData = JSON.parse(e?.data?.result);
        setDiscriptionDataFromId(finalData);
        navigate(`/blogs/:${item?.Id}`, { state: finalData });
      })
      .catch((error) => {});
  };
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      <div className="blog_wraper">
        <div className="container">
          <div className="col-lg-12">
            {blogsCardData?.length ? (
              <>
                <div className="row product_new_btm_spc_web">
                  {Array.isArray(blogsCardData) &&
                    blogsCardData.map((item, index) => (
                      <div
                        key={index}
                        className="col-lg-4 col-sm-3 col-6 product_new_btm_spc blog_product_new_btm_spc"
                      >
                        <div>
                          <div className="blog_pro_detail_wrapper_new">
                            <div className="pro_dtl_main_spc_wrapper">
                              <div className="pro_dtl_img_all_spc_wrapper blog_img_all_spc_wrapper">
                                <img
                                  src="/Images/no-product-img-700.jpg"
                                  loading="lazy"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "/Images/no-product-img-700.jpg";
                                  }}
                                />
                              </div>
                            </div>
                            <div className="blog_desc_spacing-new">
                              <div className="blog_hgt_detail">
                                <h2>{item.Title}</h2>
                                <p>{item.Description}</p>
                              </div>
                              <div>
                                <button
                                  className="common_btn w-100 blog_read_more_btn"
                                  onClick={() => handleReadMore(item)}
                                >
                                  Read More
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </>
            ) : (
              <div className="data_not-availble_box">
                <h6>No Blog Found !!!</h6>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default BlogsComponent;
